import { render, staticRenderFns } from "./UserInformationCheckingQuestion.vue?vue&type=template&id=10d1bb7f"
import script from "./UserInformationCheckingQuestion.vue?vue&type=script&lang=ts"
export * from "./UserInformationCheckingQuestion.vue?vue&type=script&lang=ts"
import style0 from "./UserInformationCheckingQuestion.vue?vue&type=style&index=0&id=10d1bb7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports